import { render } from "./LiveBtnControl.vue?vue&type=template&id=dcb98a0e"
import script from "./LiveBtnControl.vue?vue&type=script&lang=js"
export * from "./LiveBtnControl.vue?vue&type=script&lang=js"

import "./LiveBtnControl.vue?vue&type=style&index=0&id=dcb98a0e&lang=css"

import exportComponent from "C:\\yasukochi\\Work\\11_Marron\\00_Working\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__